import { memo } from 'react';
import { Row, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface CenteredSpinnerProps {
  xCentered?: boolean;
  yCentered?: boolean;
}

function CenteredSpinner({ xCentered = false, yCentered = false }: CenteredSpinnerProps) {
  return (
    <Row className="full-width" justify={xCentered ? 'center' : 'start'} align={yCentered ? 'middle' : 'top'}>
      <Spin indicator={<LoadingOutlined spin />} />
    </Row>
  );
}

export default memo(CenteredSpinner);
